import {Avatar, Button, Card, CardContent, Chip, Grid, TextField} from "@material-ui/core";
import AntDataGrid from "../../shared/components/AntDataGrid";
import React, {useMemo, useState} from "react";
import {epochToDate} from "../../shared/functions/toDateTime";
import {isArray, isEmpty} from "lodash";
import Toolbar from "@material-ui/core/Toolbar";
import clsx from "clsx";
import {lighten, makeStyles} from "@material-ui/core/styles";
import ExcelFile from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelColumn";
import useContainerDetails from "../../hooks/useContainerDetails";


const headCells = [
    {
        title: 'Image', dataIndex: 'ProductImageUrl',
        render: (image) => <Avatar alt={'...'} src={image}/>
    },
    {dataIndex: 'ProductName', title: 'Nom Produit'},
    {dataIndex: 'ProductBarcode', title: 'Code Barre'},
    {dataIndex: 'InternalId', title: 'Prosoft Code'},
    {dataIndex: 'Quantity', title: 'Quantité livrée'},
    {dataIndex: 'Price', title: " Prix d'achat "},
    {dataIndex: 'SellPrice', title: 'Prix de Vente'},
    {
        dataIndex: 'HasChilds', title: ' Pack',
        render: (flag) => <Chip label={flag ? "Oui" : "Non"} color={flag ? "primary" : "secondary"}/>
    },
    {dataIndex: 'Threshold', title: 'seuil'},
    {
        dataIndex: 'ExpirationDate', title: 'Date Expiration ',
        render: (date) => date ? epochToDate(date) : '--------'
    },
];

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.primary.main,
                backgroundColor: lighten(theme.palette.primary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.primary.dark,
            },
    title: {
        flex: '1 1 100%',
    },
}));

const EnhancedTableToolbar = ({numSelected, selectedItem, SearchBar}) => {
    const classes = useToolbarStyles();
    const areSelectedRows = numSelected > 0;
    const formated = useMemo(() => selectedItem.map(one => ({
        ...one,
        ExpirationDate: one?.ExpirationDate?.toDate() || null
    })), [selectedItem])

    return (
        <>
            <Toolbar className={clsx(classes.root, {[classes.highlight]: numSelected > 0})}>

                {
                    areSelectedRows && (
                        <Grid container className={classes.title}>
                            <Grid>
                                <Button style={{marginRight: 20}}> {"Séléctionnés : " + numSelected} </Button>
                            </Grid>
                            <Grid>
                                <ExcelFile
                                    element={
                                        (
                                            <Button style={{backgroundColor: "green", color: "white"}}>
                                                Exporter en excel
                                            </Button>
                                        )
                                    }
                                >
                                    <ExcelSheet data={formated} name="ContainerDetails">
                                        <ExcelColumn label="Code barre" value="ProductBarcode"/>
                                        <ExcelColumn label="Nom article" value="ProductName"/>
                                        <ExcelColumn label="Qté achat" value="Quantity"/>
                                        <ExcelColumn label="Prix achat" value="Price"/>
                                        <ExcelColumn label="Prix de vente" value="SellPrice"/>
                                        <ExcelColumn label="Est un pack" value="HasClilds"/>
                                        <ExcelColumn label="Seuil réaprovisionnement" value="Threshold"/>
                                        <ExcelColumn label="Date expiration" value="ExpirationDate"/>
                                    </ExcelSheet>
                                </ExcelFile>
                            </Grid>
                        </Grid>
                    )
                }

                {
                    !areSelectedRows && (
                        <SearchBar/>
                    )
                }

            </Toolbar>
        </>
    );
};


const filterList = (list, keyword) => {
    return list.filter(one => {
        const _keyword = keyword.trim().toLowerCase();
        const _internalId = one?.InternalId?.trim()?.toLowerCase() || "";
        const _barcode = one?.ProductBarcode?.trim()?.toLowerCase() || "";
        const _name = one.ProductName?.trim()?.toLowerCase();

        if (isEmpty(_keyword)) return true;

        return _name.includes(_keyword) || _barcode.includes(_keyword) || _internalId.includes(_keyword)
    })
}
const groupShipping = (shipping) => {
    let groups = []

    isArray(shipping) && shipping.forEach((e) => {
        let ex = {...e}

        let exist = groups.find(i => i.ProductId === ex.ProductId)

        if (exist) {
            exist.Quantity += ex.Quantity
            if (exist.Price < ex.Price) {
                exist.Price = ex.Price;
            }
        } else {
            groups.push(ex)
        }
    });

    return groups;
}

export default function ShippedDetailsList({containerCode}) {
    const [keyword, setKeyword] = useState('');
    const {data, loading} = useContainerDetails(containerCode);
    const groupedList = useMemo(() => groupShipping(data), [data])
    const list = useMemo(() => [...groupedList.map(one => ({key: one.ProductId, ...one}))], [groupedList]);
    const filtered = useMemo(() => filterList(list, keyword), [list, keyword])

    const handleKeywordChange = (keyword) => setKeyword(keyword);

    const SearchBar = () => {
        return (
            <TextField
                value={keyword}
                label={"Rechercher..."}
                variant={"outlined"}
                autoFocus
                onChange={event => handleKeywordChange(event.target.value)}
                style={{
                    width: 500,
                    marginTop: 10,
                    marginLeft: 10,
                    marginBottom: 30,
                }}
            />
        )
    }

    return (
        <Card style={{marginTop: 50}}>
            <CardContent>

                <AntDataGrid
                    ToolBar={(props) => (
                        <EnhancedTableToolbar
                            key={'EnhancedTableToolbar'} {...props}
                            SearchBar={() => <SearchBar key={'SearchBar'}/>}
                        />
                    )}
                    columns={headCells}
                    isLoading={loading}
                    data={filtered}
                />

            </CardContent>
        </Card>
    )
}